import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivAttendeeViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { CompanyInformation } from "./company-information.entity";
import { PersonModule } from "@/store/modules/person.store";

@IsFilterable
class AttendeeBase extends CompanyInformation implements MrfiktivAttendeeViewModelGen {
  /**
   * @inheritdoc
   */
  @FilterConfig({ displayName: "objects.attendee.firstName", type: FilterTypes.STRING })
  firstName: string;

  /**
   * @inheritdoc
   */
  @FilterConfig({ displayName: "objects.attendee.lastName", type: FilterTypes.STRING })
  lastName?: string;

  @FilterConfig({
    displayName: "objects.handover.attendee.personId",
    type: FilterTypes.OBJECT_ID,
    config: {
      itemCallback: () => PersonModule.entities,
      mapItemToComponent: item => ({ item }),
      itemValue: "id",
      component: "refs-person"
    }
  })
  personId?: string;

  get dto() {
    return {
      ...super.dto,
      firstName: this.firstName,
      lastName: this.lastName,
      personId: this.personId || null
    };
  }

  constructor(contact?: Partial<MrfiktivAttendeeViewModelGen>) {
    super(contact);
    this.firstName = contact?.firstName ?? "";
    this.lastName = contact?.lastName ?? "";
    this.personId = contact?.personId;
  }
}

type IAttendee = AttendeeBase;
const Attendee = Filter.createForClass(AttendeeBase);

export { Attendee, IAttendee };
